/**
* Adds the given attributes to all elements in the given array.
* @param elems array of elements
* @param attrs object with key-value pairs of attributes to add
*/
function addAttrsToElems(elems, attrs) {
    for (const elem of elems) {
        if (!elem)
            continue;
        for (const attr in attrs) {
            if (elem && attr) {
                elem.setAttribute(attr, attrs[attr]);
            }
        }
    }
}
function findVar(product, option1 = null, option2 = null, option3 = null) {
    return product?.variants.find(v => v.option1?.toLowerCase() === option1?.toLowerCase()
        && v.option2?.toLowerCase() === option2?.toLowerCase()
        && v.option3?.toLowerCase() === option3?.toLowerCase());
}
/**
 * Finds and returns the product variants based on the selected options.
 *
 * @returns An object containing the selected product variants, including plate variants, style, border,
 *          badge, and fixings variants.
 *
 * The function identifies the appropriate variants for front and rear plates, based on the selected
 * options such as badge, border, style, and fixings. It uses helper functions to match variant names
 * to the options provided in the `selectedOptions` object.
 */
function findVariants() {
    const product = products.find(p => p.id === defaultProduct.id);
    const { badge, badgeGroup, border, frontPlate, plateNumber: number, rearPlate, effect, thickness, fixings1, fixings2, fixings3, sloganType } = selectedOptions;
    // load style product
    const badgeProduct = products.find((p) => p.id === productIds["badges"]);
    // load style product
    const styleProduct = products.find((p) => p.id === productIds[effect]);
    const styleNumber = number === "both" ? "Pair" : number === "rear" ? "Yellow" : "White";
    // load slogan product
    const sloganProduct = products.find((p) => p.id === productIds["slogan"]);
    const plateVariants = (() => {
        const plateColor = number === "front" ? "white" : "yellow";
        const frontName = `white/${plateNumbers[frontPlate || 0]}`;
        const rearName = `yellow/${plateNumbers[rearPlate || 0]}`;
        if (number === "both") {
            return {
                type: "pair",
                variant: {
                    frontPlateVariant: findVar(product, frontName),
                    rearPlateVariant: findVar(product, rearName)
                }
            };
        }
        else {
            const plateName = plateNumbers[frontPlate || rearPlate || 0];
            const plateVariant = findVar(product, `${plateColor}/${plateName}`);
            return {
                type: "single",
                color: plateColor,
                variant: number === "front" ?
                    { frontPlateVariant: plateVariant } :
                    { rearPlateVariant: plateVariant }
            };
        }
    })();
    const fixingsTexts = [
        "sticky pads (pack of 10)",
        "screw pack",
        "number plate holder"
    ];
    const fixingsVariant1 = fixings1 ? findVar(product, `Fixings: ${fixingsTexts[0]}`) : undefined;
    const fixingsVariant2 = fixings2 ? findVar(product, `Fixings: ${fixingsTexts[1]}`) : undefined;
    const fixingsVariant3 = fixings3 ? findVar(product, `Fixings: ${fixingsTexts[2]} - ${fixings3 === true ? "both" : fixings3}`) : undefined;
    const styleVariant = findVar(styleProduct, thickness, styleNumber);
    const borderVariant = findVar(product, `Border: ${border}`);
    const badgeVariant = badgeGroup !== "NO BADGE" ? findVar(badgeProduct, badgeGroup, badge) : undefined;
    const sloganVariant = sloganType !== "no slogan" ? findVar(sloganProduct, sloganType) : undefined;
    return {
        ...plateVariants.variant,
        styleVariant,
        borderVariant,
        badgeVariant,
        fixingsVariant1,
        fixingsVariant2,
        fixingsVariant3,
        sloganVariant
    };
}
/**
 * Updates the total price displayed on the page by summing up the prices of all
 * selected product variants.
 *
 * The function is called whenever the user selects a different option in the
 * product customizer. It traverses the object returned by `findVariants()`
 * and sums up the prices of all variants. The total price is then displayed
 * in the price field element.
 */
function updatePrice() {
    const variants = Object.values(findVariants()).filter(v => v);
    const totalPrice = variants.reduce((p, c) => p + parseFloat(c?.price || "0"), 0);
    priceField && (priceField.textContent = `£${totalPrice.toFixed(2)} GBP`);
}
/**
 * Creates a proxy object that calls the provided callback function whenever one of the properties
 * in the provided object is changed. The callback function receives the name of the property that
 * changed and its new value.
 *
 * @param obj The object containing properties to watch for changes.
 * @param callback The function to call when a property changes, with the property name
 *                 and new value as arguments.
 * @returns A new proxy object that wraps the provided object and calls the callback function
 *          whenever a property is set.
 */
function createLiveWatcher(obj, callback) {
    return new Proxy(obj, {
        set(target, property, value) {
            if (Reflect.has(target, property)) {
                target[property] = value;
                callback(property, value);
                return true;
            }
            return false;
        },
    });
}

const input = document.querySelector("#reg-input");
const addToCartButton = document.querySelector("#add-to-cart-btn");
const images = JSON.parse(document.querySelector("#plate-images-array")?.textContent);
const ASSET_URL = "https://nomplates.co.uk/cdn/shop/t/15/assets/";
const priceField = document.getElementById("plate-price");
const productIds = {
    "pair": 15012760682883,
    "single": 15012769104259,
    "border colors": 7532048973995,
    "gel": 15012761239939,
    "float gel": 15012765892995,
    "carbon": 15012765663619,
    "float acrylic": 15012765958531,
    "flush XR": 15012766744963,
    "glitter bling": 15012766908803,
    "gloss 4d": 15012761010563,
    "gloss ghost": 15012763697539,
    "gloss pyramid": 15012762714499,
    "matte": 15012761829763,
    "matte ghost": 15012765434243,
    "matte pyramid": 15012765106563,
    "negative": 15012760879491,
    "shadow": 15012766155139,
    "shadow reverse": 15012766515587,
    "shadow X": 15012766417283,
    "shadow X reverse": 15012766613891,
    "2d printed": 15012769825155,
    "slogan": 7751020282027,
    "badges": 15028672004483
};
// fetch products
const res = await fetch("/products.json?limit=200");
const data = await res.json();
const products = data.products;
const defaultProduct = {
    id: productIds.pair
};
// state management
const selectedOptionsObj = {
    plateNumber: "both",
    frontPlate: 0,
    rearPlate: 0,
    effect: "2d printed",
    thickness: "Regular 2D",
    border: "No Border",
    borderColor: "",
    badgeGroup: "",
    badge: "NO BADGE",
    sloganType: "no slogan",
    sloganText: "",
    fixings1: false,
    fixings2: false,
    fixings3: false, // bool or text
};
const selectedOptions = createLiveWatcher(selectedOptionsObj, (property, value) => {
    updatePrice();
});
const maxInputLength = "9";
// plate numbers
const plateNumbers = [
    "20.5 inch Standard Size Plate",
    "18 inch Short Plate",
    "16 inch Short Plate",
    "14 inch Short Plate",
    "21 inch x 6 inch Oversize",
    "11x8 Square 4X4",
    "HEX Lambo",
    "Rover 75",
    "Bentley",
    "Jaguar",
    "Dynamic",
    "Tapered Regular",
    "Oversize Hex"
];
// plates config
const platesConfig = [
    {
        "id": "1",
        "wrapText": false,
        "maxTextLength": "8",
        "bagdeImage": { "x": "55", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "79", "y": "0", "width": "46", "height": "100%" },
        "border": { "x": "440px", "y": "center", "scale": { "x": "0.88", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "2",
        "wrapText": false,
        "maxTextLength": "7",
        "bagdeImage": { "x": "66", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "90", "y": "0", "width": "46", "height": "100%" },
        "border": { "x": "415px", "y": "center", "scale": { "x": "0.86", "y": "0.9" } },
        "toRight": "16"
    },
    {
        "id": "3",
        "wrapText": false,
        "maxTextLength": "6",
        "bagdeImage": { "x": "86", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "110", "y": "0", "width": "46", "height": "100%" },
        "border": { "x": "415px", "y": "center", "scale": { "x": "0.86", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "4",
        "wrapText": false,
        "maxTextLength": "5",
        "bagdeImage": { "x": "114", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "138", "y": "0", "width": "46", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.88", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "5",
        "wrapText": false,
        "maxTextLength": "9",
        "bagdeImage": { "x": "30", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "50", "y": "0", "width": "54", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.88", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "6",
        "wrapText": true,
        "maxTextLength": "8",
        "bagdeImage": { "x": "134", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "158", "y": "0", "width": "46", "height": "100%" },
        "border": { "x": "376px", "y": "center", "scale": { "x": "0.8", "y": "0.95" } },
        "toRight": "15"
    },
    {
        "id": "7",
        "wrapText": false,
        "maxTextLength": "6",
        "bagdeImage": { "x": "88", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "112", "y": "0", "width": "46", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.95", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "8",
        "wrapText": false,
        "maxTextLength": "9",
        "bagdeImage": { "x": "14", "y": "15", "width": "94", "height": "98" },
        "badgeCover": { "x": "0", "y": "0", "width": "94", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.95", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "9",
        "wrapText": false,
        "maxTextLength": "8",
        "bagdeImage": { "x": "34", "y": "5", "width": "94", "height": "98" },
        "badgeCover": { "x": "0", "y": "0", "width": "106", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.95", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "10",
        "wrapText": false,
        "maxTextLength": "8",
        "bagdeImage": { "x": "34", "y": "5", "width": "94", "height": "98" },
        "badgeCover": { "x": "0", "y": "0", "width": "106", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.95", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "11",
        "wrapText": false,
        "maxTextLength": "6",
        "bagdeImage": { "x": "82", "y": "32", "width": "86", "height": "84" },
        "badgeCover": { "x": "78", "y": "0", "width": "70", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.95", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "12",
        "wrapText": false,
        "maxTextLength": "7",
        "bagdeImage": { "x": "70", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "78", "y": "0", "width": "66", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.95", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "13",
        "wrapText": false,
        "maxTextLength": "9",
        "bagdeImage": { "x": "26", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "0", "y": "0", "width": "100", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.95", "y": "0.9" } },
        "toRight": "20"
    },
    {
        "id": "14",
        "wrapText": false,
        "maxTextLength": "9",
        "bagdeImage": { "x": "36", "y": "32", "width": "94", "height": "98" },
        "badgeCover": { "x": "40", "y": "0", "width": "70", "height": "100%" },
        "border": { "x": "", "y": "center", "scale": { "x": "0.95", "y": "0.9" } },
        "toRight": "20"
    }
].map(item => ({
    ...item,
    maxTextLength: `${parseInt(item.maxTextLength) + 1}`,
    bagdeImage: {
        ...item.bagdeImage,
        height: `${parseInt(item.bagdeImage.height) - 4}`,
        y: `${parseInt(item.bagdeImage.y) + 2}`,
        x: `${parseInt(item.bagdeImage.x) - 2}`,
    }
}));
const colorMap = {
    "hot pink": "#e821a6",
    "red": "#f21414",
    "orange": "#f4b150",
    "yellow": "#fce61a",
    "lime": "#c4d513",
    "green": "#72c509",
    "aqua": "#52baf7",
    "blue": "#1360e8",
    "purple": "#6a44f3",
    "burgundy": "#9d3636",
    "white": "#ffffff",
    "grey": "#a7a7a7",
    "black": "#171616",
    "metallic chrome": "#e0e0e0",
    "metallic light gold": "#e8e193",
    "metallic rose gold": "#f58d6c",
};
const availableBadges = [
    {
        name: 'Blue UK',
        badgeImage: 'BLUE_UK' // naming {group}_{color}_{badge name}
    },
    {
        name: 'Blue ENG',
        badgeImage: 'BLUE_ENG'
    },
    {
        name: 'Blue SCO',
        badgeImage: 'BLUE_SCO'
    },
    {
        name: 'Blue CYM',
        badgeImage: 'BLUE_CYM'
    },
    {
        name: 'Green plain',
        badgeImage: 'GREEN_GREEN'
    },
    {
        name: 'Green UK',
        badgeImage: 'GREEN_UK'
    },
    {
        name: 'Green ENG',
        badgeImage: 'GREEN_ENG'
    },
    {
        name: 'Green SCO',
        badgeImage: 'GREEN_SCO'
    },
    {
        name: 'Green CYM',
        badgeImage: 'GREEN_CYM'
    },
    {
        name: 'Black UK',
        badgeImage: 'BLACK_UK'
    },
    {
        name: 'Black ENG',
        badgeImage: 'BLACK_ENG'
    },
    {
        name: 'Black SCO',
        badgeImage: 'BLACK_SCO'
    },
    {
        name: 'Black CYM',
        badgeImage: 'BLACK_CYM'
    },
    {
        name: 'Union Jack',
        badgeImage: 'TRANSPARENT_UNION_JACK'
    },
    {
        name: 'Scottish Saltire',
        badgeImage: 'TRANSPARENT_SCOTTISH_SALTIRE'
    },
    {
        name: 'Northern Ireland',
        badgeImage: 'TRANSPARENT_NORTHERN_IRELAND'
    },
    {
        name: 'Ireland',
        badgeImage: 'TRANSPARENT_IRELAND'
    },
    {
        name: 'Isle of Man',
        badgeImage: 'TRANSPARENT_ISLE_OF_MAN'
    },
    {
        name: 'Union Jack Black',
        badgeImage: 'TRANSPARENT_UNION_JACK_BLACK'
    },
    {
        name: 'Palestine',
        badgeImage: 'TRANSPARENT_PALESTINE'
    },
    {
        name: 'Pakistan',
        badgeImage: 'TRANSPARENT_PAKISTAN'
    },
    {
        name: 'Kurdistan',
        badgeImage: 'TRANSPARENT_KURDISTAN'
    },
    {
        name: 'Poland',
        badgeImage: 'TRANSPARENT_POLAND'
    },
    {
        name: 'Albania',
        badgeImage: 'TRANSPARENT_ALBANIA'
    },
    {
        name: 'Bangladesh',
        badgeImage: 'TRANSPARENT_BANGLADESH'
    },
    {
        name: 'India',
        badgeImage: 'TRANSPARENT_INDIA'
    },
    {
        name: 'Kashmir',
        badgeImage: 'TRANSPARENT_KASHMIR'
    },
    {
        name: 'Transparent UK',
        badgeImage: 'TRANSPARENT_UK'
    },
    {
        name: 'Transparent ENG',
        badgeImage: 'TRANSPARENT_ENG'
    },
    {
        name: 'Transparent SCO',
        badgeImage: 'TRANSPARENT_SCO'
    },
    {
        name: 'Transparent CYM',
        badgeImage: 'TRANSPARENT_CYM'
    }
];

/**
 * Class Plate
 *
 * This class is responsible for rendering a plate with a given shape, text, color and style
 */
class Plate {
    /**
     * The shape number of the plate
     */
    shapeNumber;
    /**
     * The type of the plate (front or rear)
     */
    type;
    /**
     * The text of the plate
     */
    text;
    /**
     * The color of the plate
     */
    color;
    /**
     * The id of the plate element
     */
    id;
    /**
     * The id of the shape element
     */
    shapeId;
    /**
     * The border element
     */
    border;
    /**
     * The border class
     */
    borderClass = '';
    /**
     * The border element
     */
    borderColor = '#000';
    /**
     * Whether the plate has a border
     */
    hasBorder;
    /**
     * Whether the plate has a badge
     */
    hasBadge;
    /**
     * Whether the plate is active
     */
    active;
    /**
     * Whether the text should be wrapped
     */
    wrapText;
    /**
     * The SVG element of the plate
     */
    svg;
    /**
     * The plate container element (contains both SVG and text)
     */
    plateContainer;
    /**
     * The use element of the shape
     */
    use;
    /**
     * The shape element
     */
    shape;
    /**
     * The group element of the plate
     */
    group;
    /**
     * The foreign objects of the plate
     */
    foreignObjects;
    /**
     * The background color of the badge
     */
    badgeBgColor;
    /**
     * The badge element
     */
    badge;
    /**
     * The badge cover element
     */
    badgeCover;
    /**
     * The badge rect element
     */
    badgeRect;
    /**
     * The badge image element
     */
    badgeImage;
    /**
     * expanded means its widh is increased for fitting badge
     */
    isExpanded = false;
    /**
     * The constructor of the Plate class
     * @param id The id of the plate (front or rear)
     * @param color The color of the plate
     * @param shapeNumber The shape number of the plate
     * @param text The text of the plate
     */
    constructor(id = 'front', color = '#fff', shapeNumber = 1, text = 'YOUR REG') {
        this.shapeNumber = shapeNumber;
        this.type = id;
        this.text = text;
        this.id = `${id}_svg`;
        this.color = color;
        this.shapeId = `#${id}_shape${shapeNumber}`;
        this.border = null;
        this.hasBorder = false;
        this.hasBadge = false;
        this.active = true;
        this.wrapText = false;
        this.svg = document.getElementById(this.id);
        this.plateContainer = document.getElementById(`${id}_plate`);
        this.use = this.svg?.getElementsByTagName('use')[0];
        this.shape = this.svg?.querySelector(this.shapeId);
        this.group = this.svg?.querySelector('g');
        this.foreignObjects = this.svg?.querySelectorAll('foreignObject');
        this.badgeBgColor = '';
        this.init();
    }
    /**
     * Initializes the plate
     */
    init() {
        this.changeColor(this.color);
        this.changeShape(this.shapeId);
        this.changeText(this.text);
    }
    /**
     * Changes the color of the plate
     * @param color The new color of the plate
     */
    changeColor(color) {
        this.color = color;
        addAttrsToElems([this.svg], { fill: color });
    }
    /**
     * Changes the shape of the plate
     * @param shapeId The new shape id of the plate
     */
    changeShape(shapeId) {
        if (typeof shapeId === 'number') {
            this.shapeNumber = shapeId;
            this.shapeId = `#${this.type}_shape${shapeId}`;
            this.shape = this.svg?.querySelector(this.shapeId);
        }
        else {
            this.shapeId = shapeId;
            this.shapeNumber = parseInt(shapeId.slice(-1));
        }
        this.handleTextWrap();
        this.use?.setAttribute('xlink:href', this.shapeId);
        this.resetBorder();
        if (this.hasBadge) {
            const imageUrl = this.badgeImage?.getAttribute('href')?.split('/').pop();
            this.removeBadge();
            if (imageUrl)
                this.addBadge(imageUrl, this.badgeBgColor);
        }
        this.changeText(this.text);
    }
    /**
     * Handles the text wrap of the plate
     */
    handleTextWrap() {
        const config = platesConfig.find((p) => p?.id === this.shapeNumber.toString());
        if (config?.wrapText && !this.wrapText) {
            const texts = this.plateContainer?.querySelectorAll('.plate_text');
            this.plateContainer?.querySelector('.slogan-container')?.classList.add('go_down');
            for (let txt of Array.from(texts ?? [])) {
                txt.classList.add('wrap_text');
            }
            this.wrapText = true;
        }
        else if (!config?.wrapText && this.wrapText) {
            const texts = this.plateContainer?.querySelectorAll('.plate_text, .slogan-container');
            this.plateContainer?.querySelector('.slogan-container')?.classList.remove('go_down');
            for (let txt of Array.from(texts ?? [])) {
                txt.classList.remove('wrap_text');
            }
            this.wrapText = false;
        }
    }
    /**
     * Changes the text of the plate
     * @param txt The new text of the plate
     */
    changeText(txt) {
        const config = platesConfig.find((p) => p?.id === this.shapeNumber.toString());
        const texts = this.plateContainer?.querySelectorAll('.plate_text');
        const maxlength = parseInt(config?.maxTextLength || maxInputLength);
        const truncatedText = txt.length > maxlength ? txt.slice(txt.length - maxlength) : txt;
        for (let plateText of Array.from(texts ?? [])) {
            plateText.innerHTML = truncatedText
                .split('')
                .map((letter, index) => `<span class="char${index + 1}" >${letter}</span>`)
                .join('');
        }
        this.text = txt;
    }
    /**
     * Changes the slogan of the plate
     * @param txt The new slogan of the plate
     */
    changeSlogan(txt) {
        const slogan = this.plateContainer?.querySelector('.plate-slogan');
        if (slogan) {
            slogan.textContent = txt;
        }
    }
    /**
     * Initializes the border of the plate
     */
    borderInit() {
        const config = platesConfig.find((p) => p?.id === this.shapeNumber.toString());
        const border = config?.border;
        let scale = border?.scale;
        let transform = `${border?.x} ${border?.y}`;
        if (!this.hasBadge) {
            scale = {
                x: "0.95",
                y: "0.9"
            };
            transform = 'center';
        }
        this.border = this.shape?.cloneNode();
        if (this.border) {
            this.border.id = `${this.type}_border`;
            this.border.style.fill = '';
            this.border.style.transformOrigin = transform;
            this.border.style.transform = `scale(${scale?.x}, ${scale?.y})`;
            this.border.style.stroke = '';
            this.border.style.fillOpacity = '0';
            this.border.style.strokeWidth = '0';
            if (this.hasBadge) {
                this.group?.prepend(this.border);
            }
            else {
                this.group?.appendChild(this.border);
            }
        }
    }
    /**
     * Adds a border to the plate
     * @param color The color of the border
     */
    addBorder(color) {
        if (this.hasBorder) {
            if (this.border)
                this.border.style.stroke = color;
            this.setBorderShadowColor(color);
        }
        else {
            this.borderInit();
            if (this.border)
                this.border.style.stroke = color;
            this.setBorderShadowColor(color);
            if (this.border)
                this.border.style.strokeWidth = '2';
            this.hasBorder = true;
        }
        this.borderColor = color;
    }
    /**
     * Sets the shadow color of the border
     * @param color The color of the shadow
     */
    setBorderShadowColor(color) {
        const opacity = 'cc';
        const rgbaColor = `${this.expandHexColor(color)}${opacity}`;
        if (this.border)
            this.border.style.setProperty('--border-shadow-color', rgbaColor);
    }
    /**
     * Expands a hex color
     * @param hexColor The hex color to expand
     * @returns The expanded hex color
     */
    expandHexColor(hexColor) {
        if (hexColor.length === 4 && hexColor[0] === '#') {
            return '#' + hexColor[1] + hexColor[1] + hexColor[2] + hexColor[2] + hexColor[3] + hexColor[3];
        }
        return hexColor;
    }
    /**
     * Removes the border of the plate
     */
    removeBorder() {
        if (this.svg) {
            if (this.border)
                this.border.remove();
        }
        this.hasBorder = false;
    }
    /**
     * reset border properties
     */
    resetBorder() {
        if (this.hasBorder) {
            this.removeBorder();
            if (this.borderClass)
                this.setClassToBorder(this.borderClass);
            this.addBorder(this.borderColor);
        }
    }
    /**
     * Adds a badge to the plate
     * @param imageUrl The URL of the badge image
     * @param color The color of the badge background
     */
    addBadge(imageUrl, color = '#1b99eb') {
        const config = platesConfig.find((p) => p?.id === this.shapeNumber.toString());
        const url = ASSET_URL + imageUrl;
        if (this.hasBadge) {
            this.badgeImage?.setAttribute('href', url);
        }
        else {
            this.hasBadge = true;
            this.badgeInit();
            this.badgeCover?.setAttribute('fill', `url(#${this.type}_badge_filler)`);
            this.badge?.setAttribute('fill', `url(#${this.type}_pattern-image)`);
            this.badgeRect = this.svg?.querySelector(`#${this.type}_rect_badge`);
            this.badgeImage = this.svg?.querySelector(`#${this.type}_img`);
            if (this.badgeImage)
                addAttrsToElems([this.badgeImage], { ...config?.bagdeImage, href: url });
            if (this.foreignObjects)
                addAttrsToElems(Array.from(this.foreignObjects), { x: config?.toRight || "0" });
            // Add with-badge class to plate text elements
            const plateTexts = this.plateContainer?.querySelectorAll('.plate_text');
            plateTexts?.forEach((text) => text.classList.add('with-badge'));
        }
        // set the color and x, y, h, w to the badge filler
        if (this.badgeRect)
            addAttrsToElems([this.badgeRect], { ...config?.badgeCover, fill: "#0000" });
    }
    badgeInit() {
        this.badge = this.shape?.cloneNode();
        this.badgeCover = this.shape?.cloneNode();
        this.resetBorder();
        if (this.badge && this.badgeCover) {
            this.badge.id = `${this.type}_badge`;
            this.badgeCover.id = `${this.type}_badge_cover`;
            this.badge.style.fillOpacity = "1";
            this.badgeCover.style.fillOpacity = "1";
            this.badge.style.strokeWidth = "0";
            this.badgeCover.style.strokeWidth = "0";
            this.group?.appendChild(this.badgeCover);
            this.group?.appendChild(this.badge);
        }
    }
    /**
     * Removes the badge from the plate
     */
    removeBadge() {
        if (this.badge)
            this.badge.remove();
        if (this.badgeCover)
            this.badgeCover.remove();
        addAttrsToElems(Array.from(this.foreignObjects), { x: "0" });
        this.hasBadge = false;
        this.resetBorder();
        // Remove with-badge class from plate text elements
        const plateTexts = this.plateContainer?.querySelectorAll('.plate_text');
        plateTexts?.forEach((text) => text.classList.remove('with-badge'));
    }
    /**
     * expand the plate with
     */
    expandWidth() {
        if (this.hasBadge && [2, 3, 4].includes(this.shapeNumber)) {
            this.isExpanded = true;
            this.changeShape(this.shapeNumber - 1);
        }
    }
    /**
     * expand the plate with
     */
    restoreWidth() {
        if (!this.hasBadge && this.isExpanded && [1, 2, 3].includes(this.shapeNumber)) {
            this.isExpanded = false;
            this.changeShape(this.shapeNumber + 1);
        }
    }
    /**
     * Hides the plate
     */
    hide() {
        if (this.active) {
            if (this.plateContainer)
                this.plateContainer.style.display = 'none';
            this.active = false;
        }
    }
    /**
     * Shows the plate
     */
    show() {
        if (!this.active) {
            this.plateContainer?.style.removeProperty('display');
            this.active = true;
        }
    }
    /**
     * Changes the style of the text
     * @param style The class name of the new style
     * @param type The type of style to change, either 'effect' or 'thickness'
     */
    changeStyle(style, type) {
        const underTexts = this.plateContainer?.querySelectorAll(type === 'effect' ? '.upper, .middle, .under' : '.under');
        underTexts?.forEach((element) => {
            const classRegex = type === 'effect'
                ? /\splate_effect_[\w\d_]+/g
                : /\splate_thickness_[\w\d_]+/g;
            element.className = element.className.replaceAll(classRegex, '');
            element.classList.add(style);
        });
    }
    /**
     * Sets a class to the border of the plate
     * @param className The class name to set
     */
    setClassToBorder(className) {
        const classe = className.replace(/\s/g, "_").toUpperCase();
        this.addBorder("#000");
        this.setBorderShadowColor("#000");
        this.border && this.border.setAttribute('class', classe);
        this.borderClass = className;
    }
}

class BadgeSelector extends HTMLElement {
    selected;
    badgeGroups;
    product;
    images = [];
    constructor() {
        super();
        this.badgeGroups = [
            {
                name: "NO BADGE",
                shortcut: "NONE",
                badges: []
            },
            {
                name: "2d hd print",
                shortcut: "2D",
                badges: availableBadges.map(badge => ({ ...badge }))
            },
            {
                name: "3D Gel Domed",
                shortcut: "GEL",
                badges: availableBadges.map(badge => ({ ...badge }))
            },
            {
                name: "4D Krystal Acrylic",
                shortcut: "4D",
                badges: availableBadges.map(badge => ({ ...badge }))
            }
        ];
        this.selected = {
            group: this.badgeGroups[0].name,
            badge: this.badgeGroups[0].name,
            badgeImage: "",
            shortcut: "NONE"
        };
        this.product = products.find((p) => p.id === productIds["badges"]);
        // add image to each badge and exist propertie
        this.badgeGroups.forEach((badgeGroup) => {
            badgeGroup.badges.forEach(badge => {
                const variant = this.product?.variants.find(p => p.option1?.toLowerCase() === badgeGroup.name.toLowerCase() && p.option2?.toLowerCase() === badge.name.toLowerCase());
                if (variant) {
                    const image = variant.featured_image?.src || '';
                    badge.variantImage = image || '';
                    badge.exist = true;
                    if (image) {
                        this.images.push(image);
                    }
                }
                else {
                    badge.exist = false;
                }
            });
        });
    }
    connectedCallback() {
        this.render();
    }
    preloadImages() {
        // preload images
        this.images.forEach((image) => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = image;
            document.head.appendChild(link);
        });
    }
    convertColorToHex(color) {
        switch (color.toLowerCase()) {
            case "black":
                return '#232323';
            case "blue":
                return "#0f80db";
            case "green":
                return "#21bd4b";
            case "transparent":
                return "#0000";
            default:
                return '';
        }
    }
    render() {
        const badgeGroups = this.badgeGroups.map(group => ({
            name: group.name
        }));
        const badges = this.badgeGroups.find(g => g.name === this.selected.group)?.badges?.filter(badge => badge.exist) || [];
        this.innerHTML = `
      <div class="white-board">
      ${badgeGroups.map(group => `<div class="badge-select group ${this.selected.group === group.name ? " active" : ""}" data-badge-group="${group.name}">
            <span>${group.name}</span>
        </div>`).join("")}
      </div>
     ${badges.length ? `<div class="white-board">
      ${badges.map((badge) => `<div class="badge-select item ${this.selected.badge === badge.name ? " active" : ""}" data-badge="${badge.name}">
            <img class="badge-img" src="${badge.variantImage}" />
        </div>`).join("")}
      </div>` : ''}
      `;
        // handle click events
        const badgeSelectors = this.querySelectorAll(".badge-select");
        badgeSelectors.forEach((badgeSelect) => {
            badgeSelect.addEventListener("click", (e) => {
                let elem = e.target;
                // check if the elem is a paragraph or span, than get the parent that has "badge-select" class
                if (elem.tagName !== "DIV") {
                    elem = elem.closest('.badge-select');
                }
                const selectedBadgeGroup = elem.dataset.badgeGroup;
                const selectedBadge = elem.dataset.badge;
                if (selectedBadge) {
                    const badge = badges.find(p => p.name === selectedBadge);
                    this.selected.badge = selectedBadge;
                    this.selected.badgeImage = badge?.badgeImage || '';
                }
                else if (selectedBadgeGroup) {
                    const badgeGroup = this.badgeGroups.find(p => p.name === selectedBadgeGroup);
                    const badge = badgeGroup?.badges[0];
                    this.selected.group = selectedBadgeGroup;
                    this.selected.badge = badge?.name || '';
                    this.selected.shortcut = badgeGroup?.shortcut || '';
                    this.selected.badgeImage = badge?.badgeImage || '';
                }
                if (this.selected.group === "NO BADGE") {
                    // remove the badge
                    frontPlate.removeBadge();
                    rearPlate.removeBadge();
                    // restore the actual width
                    frontPlate.restoreWidth();
                    rearPlate.restoreWidth();
                }
                else {
                    const color = this.convertColorToHex(this.selected.badgeImage.split("_")[0]);
                    // add the badge
                    frontPlate.addBadge(`${this.selected.shortcut}_${this.selected.badgeImage}.png`, color);
                    rearPlate.addBadge(`${this.selected.shortcut}_${this.selected.badgeImage}.png`, color);
                    // expand the plate width
                    frontPlate.expandWidth();
                    rearPlate.expandWidth();
                }
                this.render();
                // update the selected product
                selectedOptions.badgeGroup = this.selected.group;
                selectedOptions.badge = this.selected.badge;
            });
        });
    }
}
customElements.define("badge-selector", BadgeSelector);

class BorderColorSelector extends HTMLElement {
    colors = [];
    selectedColor = "hot pink";
    selected = "No Border";
    product;
    constructor() {
        super();
        this.product = products.find((p) => p.id === productIds["border colors"]);
        if (this.product) {
            this.colors = this.product.options[1].values;
            this.selectedColor = this.colors[0];
            this.selected = "No Border";
        }
        this.setAttribute("selected-id", this.selected);
    }
    connectedCallback() {
        this.render();
        // Add event listener to handle clicks on style boxes
        this.addEventListener("click", (event) => {
            const styleTypeBox = event.target?.closest(".border-type");
            if (styleTypeBox) {
                const selectedType = styleTypeBox.getAttribute("data-type");
                if (selectedType) {
                    this.selected = selectedType;
                    if (this.selected.toLowerCase() === "no border") {
                        if (frontPlate.hasBorder)
                            frontPlate.removeBorder();
                        if (rearPlate.hasBorder)
                            rearPlate.removeBorder();
                    }
                    else if (this.selected.toLowerCase() === "4d acrylic") {
                        frontPlate.setClassToBorder(this.selected);
                        rearPlate.setClassToBorder(this.selected);
                        frontPlate.addBorder(this.colorToHex(this.selectedColor));
                        rearPlate.addBorder(this.colorToHex(this.selectedColor));
                    }
                    else {
                        frontPlate.setClassToBorder(this.selected);
                        rearPlate.setClassToBorder(this.selected);
                    }
                    this.render();
                    this.setAttribute("selected-id", this.selected);
                    selectedOptions.border = this.selected;
                    selectedOptions.borderColor = this.selectedColor;
                }
            }
            const styleColorBox = event.target?.closest(".border-color");
            if (styleColorBox) {
                const selectedColor = styleColorBox.getAttribute("data-color");
                if (selectedColor) {
                    this.selectedColor = selectedColor;
                    frontPlate.addBorder(this.colorToHex(this.selectedColor));
                    rearPlate.addBorder(this.colorToHex(this.selectedColor));
                    this.render();
                    selectedOptions.borderColor = this.selectedColor;
                }
            }
        });
    }
    colorToHex(colorName) {
        const hexColors = colorMap[colorName.toLowerCase()] || colorName;
        return hexColors;
    }
    getImageName(type) {
        if (!type)
            return "";
        return type.replace(/\s/g, "_").toUpperCase();
    }
    render() {
        const mainTypes = ["No Border", "Black Printed", "Black 3D Gel", "4D Acrylic"];
        // remove the "BorderType" elements
        const colors = this.colors.filter((col) => {
            return !mainTypes.includes(col);
        });
        this.innerHTML = `
        <div class="white-board">
        ${mainTypes
            .map((type) => `<div class="border-type border-select${this.selected.toLowerCase() === type.toLowerCase() ? " active" : ""}" data-type="${type}">
            ${type.toUpperCase() !== "NO BORDER"
            ? `<img class="badge-img" src="${ASSET_URL}${this.getImageName(type)}.jpeg" />`
            : `<span>${type}</span>`}
        </div>`)
            .join("")}
      </div>
        
        ${this.selected.toLowerCase() === "4d acrylic" ? `<div class="white-board">
        ${colors.map((color) => `<div style="background-color:${this.colorToHex(color)}" class="border-color color-circle${this.selectedColor === color ? " active" : ""}" data-color="${color}"></div>`)
            .join("")}
      </div>` : ''}
    `;
    }
}
customElements.define("color-selector", BorderColorSelector);

class CharacterSpacing extends HTMLElement {
    selected;
    constructor() {
        super();
        this.selected = "road legal spacing";
    }
    connectedCallback() {
        this.render();
        input.setAttribute("maxlength", maxInputLength);
        // Add event listener to handle clicks on style boxes
        this.addEventListener("click", (event) => {
            const shape = event.target?.closest(".check-field .side");
            if (shape) {
                this.selected = shape.getAttribute("data-spacing");
                if (this.selected === "road legal spacing" &&
                    input.getAttribute("maxlength") !== maxInputLength) {
                    input.value = input.value.slice(0, 8);
                    input.setAttribute("maxlength", maxInputLength);
                }
                else if (this.selected === "altered spacing" &&
                    input.getAttribute("maxlength") === maxInputLength) {
                    input.setAttribute("maxlength", "100");
                }
                this.render();
            }
        });
    }
    render() {
        this.innerHTML = `<div>
        <span class="labels">character spacing
            <div class="check-field">
            <div class="side left-side${this.selected === "road legal spacing" ? " active" : ""}" data-spacing="road legal spacing">
            <div class="point"></div>
              <span>
                Road Legal spacing
              </span>
              </div>
              <div class="side right-side${this.selected === "altered spacing" ? " active" : ""}" data-spacing="altered spacing">
            <div class="point"></div>
              <span>
                altered spacing (show plates)
              </span>
              </div>
            </div>
            </span>
      </div>`;
    }
}
customElements.define("character-spacing", CharacterSpacing);

class FixingsSelector extends HTMLElement {
    product;
    option1;
    option2;
    option3;
    selected;
    constructor() {
        super();
        this.option1 = false;
        this.option2 = false;
        this.option3 = false;
        this.selected = "both";
        this.product = products.find((p) => p.id === 8257001554231);
        this.setVariant();
    }
    connectedCallback() {
        this.render();
        // Add event listener to handle clicks on style boxes
        this.addEventListener("click", (event) => {
            const styleBox = event.target?.closest(".switch-button");
            if (styleBox) {
                const num = styleBox.getAttribute("data-option-number");
                const key = `option${num}`;
                this[key] = !this[key];
                selectedOptions.fixings1 = this.option1;
                selectedOptions.fixings2 = this.option2;
                selectedOptions.fixings3 = this.option3;
                this.render();
            }
            const shape = event.target?.closest(".check-field span");
            if (shape) {
                this.selected = shape.getAttribute("data-shape");
                selectedOptions.fixings3 = this.selected;
                this.render();
            }
        });
    }
    setVariant() {
        const title = `${this.option1 ? "yes" : "no"} / ${this.option2 ? "yes" : "no"} / ${this.option3 ? this.selected : "no"}`;
        const variant = this.product?.variants.find((v) => v.title.toLowerCase() === title.toLowerCase());
        this.setAttribute("variant-id", variant?.id.toString() || "");
        this.setAttribute("variant-price", variant?.price.toString() || "");
    }
    render() {
        this.innerHTML = `<div>
        <div class="fixings-container">
            <span class="labels">sticky pads (pack of 10)</span>
            <div class="switch-button${this.option1 ? " active" : ""}" data-option-number="1">
                <div class="switch-circle${this.option1 ? " active" : ""}"></div>
            </div>
        </div>

        <div class="fixings-container">
            <span class="labels">screw pack</span>
            <div class="switch-button${this.option2 ? " active" : ""}" data-option-number="2">
                <div class="switch-circle${this.option2 ? " active" : ""}"></div>
            </div>
        </div>

        <div class="fixings-container">
            <span class="labels">number plate holder</span>
            <div class="switch-button${this.option3 ? " active" : ""}" data-option-number="3">
                <div class="switch-circle${this.option3 ? " active" : ""}"></div>
            </div>
        </div>
        ${this.option3
            ? `<div class="check-field" data-select="${this.selected}">
        <span class="side left-side${this.selected === "front" ? " active" : ""}" data-shape="front">
          <div class="point"></div>Front Plate
        </span>
        <span class="side middle-side${this.selected === "both" ? " active" : ""}" data-shape="both">
          <div class="point"></div>Both Plates
        </span>
        <span class="side right-side${this.selected === "rear" ? " active" : ""}" data-shape="rear">
          <div class="point"></div>Rear Plate
        </span>
      </div>`
            : ""}
      </div>`;
    }
}
customElements.define("fixings-selector", FixingsSelector);

class Navigation extends HTMLElement {
    OPTION_GROUPS = [
        "size-options",
        "style-options",
        "border-options",
        "badge-options",
        "fixings-options",
        "slogan-options",
    ];
    options = ["Reg", "Style", "Border", "Badge", "Fixings", "Slogan"];
    activeGroupIndex = 0;
    constructor() {
        super();
        this.id = "navigation";
        // Attach shadow DOM
        this.attachShadow({ mode: "open" });
        this.style.width = "100%";
        this.handleShowDisableToCartBtn();
    }
    connectedCallback() {
        this.render();
    }
    scrollToNavTabs() {
        const target = document.getElementById('plate-options');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    }
    handlePaginationClick(event) {
        const target = event.target;
        if (target.closest(".prev.options-btn.on")) {
            this.navigate(-1);
        }
        else if (target.closest(".next.options-btn.on")) {
            this.navigate(1);
        }
        this.scrollToNavTabs();
        this.handleShowDisableToCartBtn();
    }
    handleTabClick(event) {
        let tab = event.target;
        if (tab.tagName === "SPAN") {
            tab = tab.parentElement;
        }
        // Handle tab click
        if (tab) {
            const prevElement = document.getElementById(this.OPTION_GROUPS[this.activeGroupIndex]);
            this.activeGroupIndex = tab.dataset['index'] !== undefined && tab.dataset['index'] !== null
                ? parseInt(tab.dataset['index'], 10)
                : 0;
            const currentElement = document.getElementById(this.OPTION_GROUPS[this.activeGroupIndex]);
            this.updateUi(prevElement, currentElement);
            this.handleShowDisableToCartBtn();
        }
    }
    navigate(direction) {
        const prevElement = document.getElementById(this.OPTION_GROUPS[this.activeGroupIndex]);
        this.activeGroupIndex = Math.max(0, Math.min(this.activeGroupIndex + direction, this.OPTION_GROUPS.length - 1));
        const currentElement = document.getElementById(this.OPTION_GROUPS[this.activeGroupIndex]);
        this.updateUi(prevElement, currentElement);
    }
    updateUi(prevElement, currentElement) {
        if (prevElement && currentElement) {
            prevElement.classList.add("hide");
            currentElement.classList.remove("hide");
            // save the scroll left value
            const previousScrollLeft = this.shadowRoot?.querySelector("#nav-tabs")?.scrollLeft;
            this.render();
            // restore the scroll left value
            requestAnimationFrame(() => {
                const newScrollableDiv = this.shadowRoot?.querySelector("#nav-tabs");
                if (newScrollableDiv) {
                    newScrollableDiv.scrollLeft = previousScrollLeft ?? 0; // Restore scroll
                }
            });
        }
    }
    handleShowDisableToCartBtn() {
        const pageIndex = this.activeGroupIndex;
        if (addToCartButton) {
            if (pageIndex === 5) {
                addToCartButton.disabled = false;
                addToCartButton.classList.remove('disable');
            }
            else {
                addToCartButton.disabled = true;
                addToCartButton.classList.add('disable');
            }
        }
    }
    render() {
        if (this.shadowRoot) {
            this.shadowRoot.innerHTML = `
                    <style>
                    #nav-tabs {
                        display: flex;
                        gap: 10px;
                        width: 100%;
                    }

                    #nav-tabs div {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 8px;
                        border-bottom: 4px solid #fff;
                        cursor: pointer;
                        width: calc(100%/6);
                    }

                    #nav-tabs div span {
                        text-align: center;
                        color: #363232ab;
                        font-size: 16px;
                        font-family: Poppins;
                        text-transform: capitalize;
                        user-select: none;
                    }

                    #nav-tabs div.active {
                        border-bottom-color: #FDC83F;
                        cursor: initial;
                    }

                    #nav-tabs div.active span {
                        color: #212121;
                    }
                    #option-navigation {
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-pack: justify;
                        -ms-flex-pack: justify;
                        justify-content: space-between;
                    }


                    #option-navigation .options-btn {
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        padding: 12px 24px;
                        -webkit-box-pack: justify;
                        -ms-flex-pack: justify;
                        justify-content: space-between;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        border-radius: 4px;
                        cursor: pointer;
                        user-select: none;
                        font-weight: 600;
                    }

                    #option-navigation .prev.options-btn {
                        color: white;
                        background: #939393;
                    }

                    #option-navigation .next.options-btn {
                        color: black;
                        background: #ffff00;
                    }
                    #option-navigation .prev.options-btn.off {
                        opacity: 0.7;
                    }
                    #option-navigation .next.options-btn.off {
                        opacity: 0;
                    }
                    @media screen and (max-width: 640px) {
                        .mb__sroll__x {
                            overflow-x: auto;
                            scrollbar-width: none;
                            -ms-overflow-style: none;
                        }

                        .mb__sroll__x::-webkit-scrollbar {
                            display: none;
                        }

                        .mb__sroll__x>div {
                            min-width: 100px;
                        }
                    }
                    @media screen and (max-width: 400px) {
                        #nav-tabs div span {
                            font-size: 12px;
                        }
                    }
                    </style>
                        <div id="nav-tabs" class="mb__sroll__x" >
                                ${this.options
                .map((op, id) => `
                                        <div data-index="${id}" ${id === this.activeGroupIndex ? 'class="active"' : ""}>
                                            <span>${op}</span>
                                        </div>
                                    `)
                .join("")}
                        </div>
                        <slot></slot>
                    <div id="option-navigation">
                            <div class="prev options-btn ${this.activeGroupIndex < 1 ? "off" : "on"}">
                                <span>BACK</span>
                            </div>
                            <div class="next options-btn ${this.activeGroupIndex < this.OPTION_GROUPS.length - 1 ? "on" : "off"}">
                                <span>NEXT</span>
                            </div>
                        </div>
                    `;
            let tabs = this.shadowRoot?.querySelectorAll("#nav-tabs div:not(.active)");
            let btns = this.shadowRoot?.querySelectorAll("#option-navigation div");
            tabs?.forEach(tab => {
                tab.addEventListener("click", this.handleTabClick.bind(this));
            });
            btns?.forEach(btn => {
                btn.addEventListener("click", this.handlePaginationClick.bind(this));
            });
        }
    }
}
customElements.define("navigation-component", Navigation);

class PlateImageSlider extends HTMLElement {
    selected;
    images;
    /**
     * Constructs a new PlateImageSlider element
     */
    constructor() {
        super();
        this.selected = 0;
        this.images = images;
    }
    connectedCallback() {
        this.render();
    }
    updateImages(images) {
        this.images = images;
        this.render();
    }
    render() {
        this.innerHTML = `<div id="plate-images">
        <div class="slide left">
          <i class="fa-solid fa-angle-left"></i>
        </div>
        ${this.images.map((image, i) => `<img src="${image}" class="${this.selected === i ? "active" : ""}" alt="plate image" />`)
            .join("")}
        <div class="slide right">
          <i class="fa-solid fa-angle-right"></i>
        </div>
      </div>
      </div>`;
        // hadle slide left and right
        const left = this.querySelector(".slide.left");
        const right = this.querySelector(".slide.right");
        left.addEventListener("click", () => {
            if (this.selected <= 0) {
                this.selected = this.images.length - 1;
            }
            else {
                this.selected--;
            }
            this.render();
        });
        right.addEventListener("click", () => {
            if (this.selected >= this.images.length - 1) {
                this.selected = 0;
            }
            else {
                this.selected++;
            }
            this.render();
        });
    }
}
customElements.define("plate-image-slider", PlateImageSlider);

class PlateNumber extends HTMLElement {
    selected;
    constructor() {
        super();
        this.selected = "both";
        this.setAttribute("selected-id", this.selected);
    }
    connectedCallback() {
        this.render();
        input.setAttribute("maxlength", maxInputLength);
        // Add event listener to handle clicks on style boxes
        this.addEventListener("click", (event) => {
            const shape = event.target?.closest(".check-field .side");
            if (shape) {
                this.selected = shape.getAttribute("data-plate-number");
                this.dispatchEvent(new CustomEvent("selectedChanged", {
                    detail: { selected: this.selected },
                }));
                switch (this.selected) {
                    case "both":
                        if (!frontPlate.active)
                            frontPlate.show();
                        if (!rearPlate.active)
                            rearPlate.show();
                        if (!frontShapeSelector.active)
                            frontShapeSelector.show();
                        if (!rearShapeSelector.active)
                            rearShapeSelector.show();
                        // set the product id
                        defaultProduct.id = productIds.pair;
                        break;
                    case "front":
                        if (!frontPlate.active)
                            frontPlate.show();
                        if (rearPlate.active)
                            rearPlate.hide();
                        if (!frontShapeSelector.active)
                            frontShapeSelector.show();
                        if (rearShapeSelector.active)
                            rearShapeSelector.hide();
                        // set the product id
                        defaultProduct.id = productIds.single;
                        break;
                    case "rear":
                        if (frontPlate.active)
                            frontPlate.hide();
                        if (!rearPlate.active)
                            rearPlate.show();
                        if (frontShapeSelector.active)
                            frontShapeSelector.hide();
                        if (!rearShapeSelector.active)
                            rearShapeSelector.show();
                        // set the product id
                        defaultProduct.id = productIds.single;
                        break;
                }
                this.render();
                this.setAttribute("selected-id", this.selected);
                selectedOptions.plateNumber = this.selected;
                this.addClasses();
            }
        });
    }
    addClasses() {
        const platesBackground = document.getElementById('plates-bg');
        if (this.selected === "both") {
            if (platesBackground?.classList.contains("rear")) {
                platesBackground?.classList.remove("rear");
            }
            if (platesBackground?.classList.contains("front")) {
                platesBackground?.classList.remove("front");
            }
        }
        else if (["both", "front"].includes(this.selected)) {
            if (!platesBackground?.classList.contains("front")) {
                platesBackground?.classList.add("front");
            }
            if (platesBackground?.classList.contains("rear")) {
                platesBackground?.classList.remove("rear");
            }
        }
        else if (["both", "rear"].includes(this.selected)) {
            if (!platesBackground?.classList.contains("rear")) {
                platesBackground?.classList.add("rear");
            }
            if (platesBackground?.classList.contains("front")) {
                platesBackground?.classList.remove("front");
            }
        }
    }
    renderOption(title, label, className) {
        return `
     <div class="side ${className}" data-plate-number="${title}">
        <div class="point"></div>
          <span>
            ${label}
          </span>
      </div>
    `;
    }
    render() {
        this.innerHTML = `
        <div>
        <span class="labels">select number plate you need
            <div class="check-field">
            ${this.renderOption('front', 'Front Plate', this.selected === "front" ? "left-side active" : "left-side")}
            ${this.renderOption('both', 'Both Plate', this.selected === "both" ? "middle-side active" : "middle-side")}
            ${this.renderOption('rear', 'Rear Plate', this.selected === "rear" ? "right-side active" : "right-side")}
            </div>
            </span>
      </div>`;
    }
}
customElements.define("plate-number", PlateNumber);

class SelectShape extends HTMLElement {
    open;
    active;
    selected;
    type;
    zIndex;
    images;
    options;
    product;
    constructor(zIndex = 0, type = "front") {
        super();
        this.open = false;
        this.active = true;
        this.selected = 0;
        this.type = type;
        this.id = type;
        this.zIndex = zIndex;
        this.images = [];
        let options = [];
        const placeholderImageSrc = ASSET_URL + "plate_number_place_holder.png";
        this.product = products.find((p) => p.id === productIds["pair"]);
        if (type === "front") {
            this.images = this.product?.variants.filter(v => v.option1?.toLowerCase().includes('white')).map(v => v.featured_image?.src || placeholderImageSrc) || [];
            options = this.product?.options[0].values.filter(v => v.toLowerCase().includes("white")).map(v => v.replace('white/', '')) || [];
        }
        else if (type === "rear") {
            this.images = this.product?.variants.filter(v => v.option1?.toLowerCase().includes('yellow')).map(v => v.featured_image?.src || placeholderImageSrc) || [];
            options = this.product?.options[0].values.filter(v => v.toLowerCase().includes("yellow")).map(v => v.replace('yellow/', '')) || [];
        }
        this.options = options.map((option, index) => {
            let plateIndex = plateNumbers.findIndex(name => name.toLowerCase() === option.toLowerCase());
            if (plateIndex === -1) {
                plateIndex = 0;
            }
            return ({
                id: plateIndex,
                index,
                name: option
            });
        }).sort((a, b) => a.id - b.id);
        this.addEventListener("click", this.handleClick.bind(this));
        this.setAttribute("selected-id", this.selected.toString());
    }
    connectedCallback() {
        const plateNumberElement = document.querySelector("plate-number");
        // @ts-ignore
        plateNumberElement?.addEventListener("selectedChanged", (event) => {
            this.setup(event.detail.selected);
            this.render();
        });
        this.render();
    }
    setup(selected) {
        if (!this.active) {
            if (selected === "both" || selected === this.type) {
                this.show();
            }
        }
        else {
            if (selected !== "both" && selected !== this.type) {
                this.hide();
            }
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "selected-id" && oldValue !== newValue) {
            this.selected = parseInt(newValue || "0");
            this.render();
        }
    }
    handleClick() {
        this.open = !this.open;
        this.render();
        if (this.open) {
            const shapeElements = this.querySelectorAll(".shape");
            shapeElements.forEach((shape, index) => {
                const shapeId = parseInt(shape.dataset["number"] || "0", 10) + 1;
                shape.addEventListener("click", () => this.handleShapeClick(shapeId));
            });
        }
    }
    handleShapeClick(shapeId) {
        this.selected = shapeId - 1;
        if (this.type === "front") {
            frontPlate.changeShape(shapeId);
            frontPlate.expandWidth();
        }
        else {
            rearPlate.changeShape(shapeId);
            rearPlate.expandWidth();
        }
        this.setAttribute("selected-id", this.selected.toString());
        if (this.id === "front") {
            selectedOptions.frontPlate = this.selected;
        }
        else {
            selectedOptions.rearPlate = this.selected;
        }
    }
    hide() {
        if (this.active) {
            this.style.display = "none";
            this.active = false;
        }
    }
    show() {
        if (!this.active) {
            this.style.removeProperty("display");
            this.active = true;
        }
    }
    shapesList() {
        return `
        <div class="shapes-list">
            ${this.options?.map((option) => `
                        <div class="shape" data-number="${option.id}">
                <img class="plate-img" src="${this.images?.[option.index]}" alt="">
                <span class="plate-name">${option.name}</span>
            </div>
            `)
            .join("")}
        </div>
        `;
    }
    render() {
        const selectedOption = this.options?.find((o) => o.id === this.selected);
        this.innerHTML = `
        <div>
            <span class="labels">Select the ${this.type} plate size</span>
            <div class="select-container" style="z-index: ${this.zIndex}">
                <div class="select-plates">
                    <div>
                        <img class="plate-img" src="${this.images?.[selectedOption?.index || 0] || ""}" alt="">
                        <span class="plate-name" >${selectedOption?.name || ""}</span>
                    </div>
                    <i class="fa-solid fa-chevron-${this.open ? "up" : "down"}"></i>
                </div>
                ${this.open ? this.shapesList() : ""}
            </div>
        </div>`;
    }
}
customElements.define("select-shape", SelectShape);

class SloganSelector extends HTMLElement {
    sloganTypes;
    inputedValue = "";
    selected = "no slogan";
    option1 = false;
    option2 = false;
    option3 = false;
    product;
    images = [];
    constructor() {
        super();
        this.sloganTypes = [
            {
                name: 'no slogan',
                class: 'slogan__none'
            },
            {
                name: 'Lipped (road legal)',
                class: 'slogan__lipped'
            },
            {
                name: '4d laser cut',
                class: 'slogan__4d_laser_cut'
            },
            {
                name: 'printed standard',
                class: 'slogan__printed_standard'
            },
            {
                name: 'laser engraved',
                class: 'slogan__laser_engraved'
            }
        ];
        this.inputedValue = "";
        this.selected = this.sloganTypes[0].name;
        this.product = products.find((p) => p.id === productIds["slogan"]);
        this.sloganTypes.forEach((s) => {
            const image = this.product?.variants.find(p => p.option1?.toLowerCase() === s.name.toLowerCase())?.featured_image.src;
            s.image = image || '';
        });
    }
    /**
     * This function is called when the custom element is inserted into the DOM.
     * It sets up event listeners for clicks on the style boxes and for input in the text box.
     */
    connectedCallback() {
        // We need to render the component before we can add event listeners
        this.render();
    }
    render() {
        const stylesBoard = `
        <div class="white-board">
        ${this.sloganTypes
            .map((slogan) => `<div class="slogan-select${this.selected === slogan.name ? " active" : ""}" data-slogan="${slogan.name}">
                        ${slogan.name !== "no slogan"
            ? `<img class="slogan-img" src="${slogan.image}" />`
            : `<span>${slogan.name}</span>`}
                    </div>`)
            .join("")}
      </div>
        `;
        this.innerHTML = `
        ${stylesBoard}
    ${this.selected !== "no slogan" ? `<div>
          <label class="labels" for="slog-input">enter a slogan for your plate</label>
          <input id="slog-input" placeholder="Your Slogan" class="input" value="${selectedOptions.sloganText}" >
        </div>` : ''}
    `;
        // Get the input element
        const sloganInput = document.querySelector("#slog-input");
        // Add an event listener to the input element
        sloganInput?.addEventListener("input", (event) => {
            // Get the value of the input element
            // The value is the text that the user has typed into the input field
            this.inputedValue = event.target?.value || "";
            changeSlogantext(event.target?.value);
        });
        // handle clicks on style boxes
        // handle click events
        const sloganSelectors = this.querySelectorAll(".slogan-select");
        sloganSelectors.forEach((sloganSelect) => {
            sloganSelect.addEventListener("click", (e) => {
                let elem = e.target;
                // check if the elem is a paragraph or span, than get the parent that has "slogan-select" class
                if (elem.tagName !== "DIV") {
                    elem = elem.closest('.slogan-select');
                }
                this.selected = elem.dataset.slogan;
                selectedOptions.sloganType = this.selected;
                if (this.selected === "no slogan") {
                    this.inputedValue = "";
                    changeSlogantext("");
                }
                this.render();
            });
        });
    }
}
customElements.define("slogan-selector", SloganSelector);

class StyleSelector extends HTMLElement {
    styles;
    selected;
    product;
    activeThickness;
    defaultThickness;
    images = [];
    displayThickness = false;
    isTheLastPage = false;
    isTheFirstPage = false;
    currentPage = 1;
    itemsPerPage = 3;
    renderCount = 0;
    constructor() {
        super();
        this.styles = [
            {
                label: 'Plate Number Effects',
                name: 'effects',
                data: [
                    { name: '2d printed', class: 'plate_effect_2d_printed', images: products.find(p => p.id === productIds["2d printed"])?.images?.map(i => i.src) },
                    { name: 'gel', class: 'plate_effect_gel', images: products.find(p => p.id === productIds["gel"])?.images?.map(i => i.src) },
                    { name: 'gloss 4d', class: 'plate_effect_gloss_4d', images: products.find(p => p.id === productIds["gloss 4d"])?.images?.map(i => i.src) },
                    { name: 'matte', class: 'plate_effect_matte', images: products.find(p => p.id === productIds["matte"])?.images?.map(i => i.src) },
                    { name: 'gloss ghost', class: 'plate_effect_gloss_ghost', images: products.find(p => p.id === productIds["gloss ghost"])?.images?.map(i => i.src) },
                    { name: 'matte ghost', class: 'plate_effect_matte_ghost', images: products.find(p => p.id === productIds["matte ghost"])?.images?.map(i => i.src) },
                    { name: 'negative', class: 'plate_effect_negative', images: products.find(p => p.id === productIds["negative"])?.images?.map(i => i.src) },
                    { name: 'float gel', class: 'plate_effect_float_gel', images: products.find(p => p.id === productIds["float gel"])?.images?.map(i => i.src) },
                    { name: 'float acrylic', class: 'plate_effect_float_acrylic', images: products.find(p => p.id === productIds["float acrylic"])?.images?.map(i => i.src) },
                    { name: 'carbon', class: 'plate_effect_carbon', images: products.find(p => p.id === productIds["carbon"])?.images?.map(i => i.src) },
                    { name: 'gloss pyramid', class: 'plate_effect_gloss_pyramid', images: products.find(p => p.id === productIds["gloss pyramid"])?.images?.map(i => i.src) },
                    { name: 'matte pyramid', class: 'plate_effect_matte_pyramid', images: products.find(p => p.id === productIds["matte pyramid"])?.images?.map(i => i.src) },
                    { name: 'shadow', class: 'plate_effect_shadow', images: products.find(p => p.id === productIds["shadow"])?.images?.map(i => i.src) },
                    { name: 'shadow reverse', class: 'plate_effect_shadow_reverse', images: products.find(p => p.id === productIds["shadow reverse"])?.images?.map(i => i.src) },
                    { name: 'shadow X', class: 'plate_effect_shadow_x', images: products.find(p => p.id === productIds["shadow X"])?.images?.map(i => i.src) },
                    { name: 'shadow X reverse', class: 'plate_effect_shadow_x_reverse', images: products.find(p => p.id === productIds["shadow X reverse"])?.images?.map(i => i.src) },
                    { name: 'flush XR', class: 'plate_effect_flush_xr', images: products.find(p => p.id === productIds["flush XR"])?.images?.map(i => i.src) },
                ],
            },
            {
                label: 'Plate Number Thickness',
                name: 'thickness',
                data: [
                    { name: "none", class: "plate_thickness_0mm", images: undefined },
                    { name: "Regular 2D", class: "plate_thickness_0mm", images: undefined },
                    { name: "1.5mm", class: "plate_thickness_3mm", images: undefined },
                    { name: "Gloss", class: "plate_thickness_8mm", images: undefined },
                    { name: "2mm", class: "plate_thickness_3mm", images: undefined },
                    { name: "3mm", class: "plate_thickness_3mm", images: undefined },
                    { name: "4mm", class: "plate_thickness_4mm", images: undefined },
                    { name: "5mm", class: "plate_thickness_5mm", images: undefined },
                    { name: "6mm", class: "plate_thickness_6mm", images: undefined },
                    { name: "7mm", class: "plate_thickness_7mm", images: undefined },
                    { name: "8mm", class: "plate_thickness_8mm", images: undefined },
                    { name: "9mm", class: "plate_thickness_9mm", images: undefined },
                    { name: "10mm", class: "plate_thickness_10mm", images: undefined },
                    { name: "11mm", class: "plate_thickness_11mm", images: undefined },
                ]
            }
        ];
        this.defaultThickness = this.styles[1].data;
        this.selected = { effect: "2d printed", thickness: "Regular 2D" };
        // get the product id related to effects
        const effetProductIds = Object.entries(productIds)
            .filter(([key, value]) => this.styles[0].data.find(d => d.name === key))
            .map(([key, value]) => value);
        this.images = products.filter(p => effetProductIds.includes(p.id))
            .filter((p) => p.images[0])
            .map((p) => p.images[0].src);
        this.updateProduct();
        this.setVariant();
        this.setAttribute("selected-id", Object.values(this.selected).join('-'));
    }
    connectedCallback() {
        // adjust the number of items per page depend on the page width
        this.render();
        this.preloadImages();
        setTimeout(() => {
            this.updateCarouselImages();
        }, 2000);
    }
    updateProduct() {
        this.product = products.find((p) => p.id === productIds[this.selected.effect]);
        // get active thickness
        this.activeThickness = this.product?.options.find(p => p.name === "Letter Depth")?.values;
        this.selected.thickness = this.activeThickness?.[0] || "5mm";
        this.updateThicknessUI();
    }
    updateCarouselImages() {
        const newImages = this.styles[0].data.find(d => d.name === this.selected.effect)?.images || [];
        plateImagesSlider.updateImages(newImages);
    }
    handleClick(selectedStyletype) {
        // get the style from the selected style and the appropriate class name
        const style = this.styles.find((p) => p.data.some(d => d.name === this.selected[selectedStyletype]));
        const className = style?.data.find(d => d.name === this.selected[selectedStyletype])?.class ?? '';
        // handle updating plates style
        frontPlate.changeStyle(className, selectedStyletype);
        rearPlate.changeStyle(className, selectedStyletype);
        // handle rendering the ui and updating "selected-id" attribute
        this.setVariant();
        this.setAttribute("selected-id", Object.values(this.selected).join('-'));
        // displayThickness
        this.displayThickness = true;
        // handle update product
        if (selectedStyletype === 'effect') {
            this.updateProduct();
            // remove the 'active' class from all elements and give it to the first thickness with data-style-name = this.selected.thickness[0].name
            const elem = this.querySelector(`[data-style-name="${this.selected.thickness}"]`);
            this.querySelectorAll(".thickness.active").forEach(p => p.classList.remove('active'));
            elem?.classList.add('active');
            this.scrollThicknessPart();
        }
        // handle updating product and price
        selectedOptions.effect = this.selected.effect;
        selectedOptions.thickness = this.selected.thickness;
        // upadate images
        this.updateCarouselImages();
    }
    scrollThicknessPart() {
        const target = this.querySelector('#thickness');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
    setVariant() {
        const plateNumber = document.querySelector("plate-number")?.getAttribute("selected-id");
        const variant = this.product?.variants.find((v) => v.option1?.toLowerCase() === plateNumber?.toLowerCase() &&
            v.option2?.toLowerCase() === Object.values(this.selected).join('-').toLowerCase());
        if (variant) {
            this.setAttribute("variant-id", variant.id.toString());
            this.setAttribute("variant-price", variant.price.toString());
        }
    }
    preloadImages() {
        const allEffects = this.styles[0]?.data || [];
        // get the images
        const images = [];
        allEffects.forEach((effect) => {
            if (effect.images) {
                images.push(...effect.images);
            }
        });
        // preload images
        images.forEach((image) => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = image;
            document.head.appendChild(link);
        });
    }
    updateEffectUI = () => {
        this.styles[1].data = this.defaultThickness.filter((d) => this.activeThickness?.includes(d.name));
        const effects = this.styles[0].data;
        const effectContainer = this.querySelector('#effect');
        if (effectContainer) {
            // Save the current scroll position
            const scrollPosition = effectContainer.scrollTop;
            effectContainer.innerHTML = effects.map(effect => ` <div class="effect image-container ${this.selected["effect"] === effect.name ? " active" : ""}" data-style-name="${effect.name}" >
        <img src="${effect.images?.[0]}" alt="${effect.name}">
        <span class="title" >${effect.name}</span>
      </div>`).join("");
            // Restore the scroll position
            effectContainer.scrollTop = scrollPosition;
        }
        else {
            this.innerHTML = `<div>
            <span class="labels">${this.styles[0].label}</span>
            <div class="white-board scroll-box relative" id="scroll-box">
            <div class="tutorial-overlay" id="tutorial">
            <div class="icon">⬇️</div> <!-- Down arrow icon -->
            <h2>Welcome!</h2>
            <p>Scroll down to explore the images below.</p>
            </div>
            <div id="effect" class="scroll-content">
            ${effects.map(effect => ` <div class="effect image-container visible${this.selected["effect"] === effect.name ? " active" : ""}" data-style-name="${effect.name}" >
            <img src="${effect.images?.[0]}" alt="${effect.name}">
            <span class="title" >${effect.name}</span>
          </div>`).join("")}
            </div>
            </div>
          </div>
          `;
        }
    };
    updateThicknessUI = () => {
        this.styles[1].data = this.defaultThickness.filter((d) => this.activeThickness?.includes(d.name));
        const thickness = this.styles[1].data;
        const thicknessContainer = this.querySelector('#thickness');
        if (thicknessContainer) {
            thicknessContainer.innerHTML = thickness.map((style, idx) => `<div class="style-box relative thickness${this.selected["thickness"] === style.name ? " active" : ""}" data-style-name="${style.name}"
                    >
                    <span class="style__name">${style.name}</span>
                    <div id="thickness-container">
                        <div class="top_layer thickness_${style.name.toLowerCase().replaceAll(' ', '_')} effect_${this.selected.effect.toLowerCase().replaceAll(' ', '_')}"></div>
                        <div class="middle_layer thickness_${style.name.toLowerCase().replaceAll(' ', '_')} effect_${this.selected.effect.toLowerCase().replaceAll(' ', '_')}"></div>
                        <div class="bottom_layer thickness_${style.name.toLowerCase().replaceAll(' ', '_')} effect_${this.selected.effect.toLowerCase().replaceAll(' ', '_')}"></div>
                    </div>
                    </div>`).join("");
        }
        else {
            this.innerHTML += `<div id="thickness-part" >
            <span class="labels">${this.styles[1].label}</span>
            <div class="white-board">
            <div id="thickness" class="grid mb__sroll__x">
            ${thickness
                .map((style, idx) => `<div class="style-box relative thickness${this.selected["thickness"] === style.name ? " active" : ""}" data-style-name="${style.name}"
                            >
                            <span class="style__name">${style.name}</span>
                            <div id="thickness-container">
                                <div class="top_layer thickness_${style.name.toLowerCase().replaceAll(' ', '_')} effect_${this.selected.effect.toLowerCase().replaceAll(' ', '_')}"></div>
                                <div class="middle_layer thickness_${style.name.toLowerCase().replaceAll(' ', '_')} effect_${this.selected.effect.toLowerCase().replaceAll(' ', '_')}"></div>
                                <div class="bottom_layer thickness_${style.name.toLowerCase().replaceAll(' ', '_')} effect_${this.selected.effect.toLowerCase().replaceAll(' ', '_')}"></div>
                            </div>
                            </div>`)
                .join("")}
                    </div>
          </div>
          </div>`;
        }
        const thicknessElements = this.querySelectorAll(".thickness");
        thicknessElements.forEach((thick) => {
            thick.addEventListener("click", (e) => {
                let elem = e.target;
                // check if the elem is a paragraph or span, than get the parent that has "style-box" class
                if (elem.tagName !== "DIV") {
                    elem = elem.closest('.thickness');
                }
                // if element has "active" class, return
                if (elem.classList.contains("active")) {
                    return;
                }
                this.selected.thickness = elem?.dataset.styleName;
                this.handleClick("thickness");
                // remove the 'active' class from all elements and give it to the clicked element
                this.querySelectorAll(".thickness.active").forEach(p => p.classList.remove('active'));
                elem.classList.add('active');
            });
        });
    };
    render() {
        this.updateEffectUI();
        this.updateThicknessUI();
        // hide the thcness part before the first click
        const thicknessPart = this.querySelector("thickness-part");
        if (thicknessPart) {
            thicknessPart.style.display = this.displayThickness ? "block" : "none";
        }
        // handle click events
        const effectElements = this.querySelectorAll(".effect");
        const zoomInElements = this.querySelectorAll(".zoom_in_feature");
        effectElements.forEach((effect) => {
            effect.addEventListener("click", (e) => {
                let elem = e.target;
                // check if the elem is a paragraph or span, than get the parent that has "style-box" class
                if (elem.tagName !== "DIV") {
                    elem = elem.closest('.effect');
                }
                // if element has "active" class, return
                if (elem.classList.contains("active")) {
                    return;
                }
                this.selected.effect = elem?.dataset.styleName;
                this.handleClick("effect");
                // remove the 'active' class from all elements and give it to the clicked element
                this.querySelectorAll(".effect.active").forEach(p => p.classList.remove('active'));
                elem.classList.add('active');
            });
        });
        zoomInElements.forEach((zoomInElement) => {
            // change the background image size and position
            zoomInElement.addEventListener("mousemove", (e) => {
                let elem = e.target;
                // check if the elem is a paragraph or span, than get the parent that has "zoom_in_feature" class
                if (elem.tagName !== "DIV") {
                    elem = elem.closest('.zoom_in_feature');
                }
                // change the background image size and position
                elem.style.backgroundSize = "200%";
                elem.style.backgroundPositionX = ((e.offsetX * 100) / elem.offsetWidth) + "%";
                elem.style.backgroundPositionY = ((e.offsetY * 100) / elem.offsetHeight) + "%";
            });
            zoomInElement.addEventListener("mouseout", (e) => {
                let elem = e.target;
                // check if the elem is a paragraph or span, than get the parent that has "zoom_in_feature" class
                if (elem.tagName !== "DIV") {
                    elem = elem.closest('.zoom_in_feature');
                }
                // change the background image size and position
                elem.style.backgroundSize = "cover";
                elem.style.backgroundPositionX = "center";
                elem.style.backgroundPositionY = "center";
            });
        });
        // Add scroll listener
        const containers = this.querySelectorAll('.image-container');
        const tutorial = document.getElementById('tutorial');
        const scrollBox = document.getElementById('scroll-box');
        const options = {
            threshold: 0.1, // Trigger when 50% of the element is visible
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const img = entry.target;
                if (entry.isIntersecting) {
                    img?.classList.add('visible');
                }
                else {
                    img?.classList.remove('visible');
                }
            });
        }, options);
        containers.forEach(container => observer.observe(container));
        // Hide the tutorial overlay when the user scrolls
        scrollBox?.addEventListener('scroll', () => {
            if (!tutorial?.classList.contains('hidden')) {
                tutorial?.classList.add('hidden'); // Animate fade out
                setTimeout(() => {
                    if (tutorial) {
                        tutorial.style.display = 'none';
                    }
                }, 500); // Match animation duration
            }
        });
        // Automatically hide tutorial after 7 seconds if no scrolling happens
        setTimeout(() => {
            if (!tutorial?.classList.contains('hidden')) {
                tutorial?.classList.add('hidden');
                setTimeout(() => {
                    if (tutorial) {
                        tutorial.style.display = 'none';
                    }
                }, 500);
            }
        }, 7000);
    }
}
customElements.define("style-selector", StyleSelector);

const frontPlate = new Plate();
const rearPlate = new Plate("rear", "#ff0");
const frontShapeSelector = new SelectShape(4, "front");
const rearShapeSelector = new SelectShape(3, "rear");
const plateImagesSlider = new PlateImageSlider();
const sizeOptionsContainer = document.getElementById("size-options");
sizeOptionsContainer?.append(frontShapeSelector);
sizeOptionsContainer?.append(rearShapeSelector);
const plateImagesContainer = document.getElementById("plate-images-container");
plateImagesContainer?.append(plateImagesSlider);
// change plates text from reg input
function changePlatestext(text) {
    frontPlate.changeText(text);
    rearPlate.changeText(text);
}
input?.addEventListener("input", (event) => {
    changePlatestext(event.target?.value);
});
function changeSlogantext(text) {
    frontPlate.changeSlogan(text);
    rearPlate.changeSlogan(text);
    selectedOptions.sloganText = text;
}
updatePrice();
/// add to cart
function addToCart() {
    const { badgeVariant, borderVariant, styleVariant, frontPlateVariant, rearPlateVariant, fixingsVariant1, fixingsVariant2, fixingsVariant3, sloganVariant } = findVariants();
    // extra values
    const { border, borderColor, sloganText } = selectedOptions;
    const productId = Math.floor(Math.random() * 9999999);
    const items = [
        {
            quantity: 1,
            id: frontPlateVariant?.id,
            properties: { Registration: input?.value, productId },
        },
        {
            quantitys: 1,
            id: rearPlateVariant?.id,
            properties: { Registration: input?.value, productId },
        },
        {
            quantity: 1,
            id: styleVariant?.id,
            properties: { productId },
        },
        {
            quantity: 1,
            id: borderVariant?.id,
            properties: { productId, "Border Color": border.toLowerCase() === "4d acrylic" ? borderColor : undefined },
        },
        {
            quantity: 1,
            id: badgeVariant?.id,
            properties: { productId },
        },
        {
            quantity: 1,
            id: fixingsVariant1?.id,
            properties: { productId },
        },
        {
            quantity: 1,
            id: fixingsVariant2?.id,
            properties: { productId },
        },
        {
            quantity: 1,
            id: fixingsVariant3?.id,
            properties: { productId, "Plate Number": fixingsVariant3 ? document.querySelector('fixings-selector .check-field')?.dataset["select"] : "" },
        },
        {
            quantity: 1,
            id: sloganVariant?.id,
            properties: { productId, Slogan: sloganText },
        },
    ];
    const btnText = addToCartButton?.querySelector("span");
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: items.filter((p) => p.id) }),
    })
        .then((response) => {
        // Check if the response is successful (status code 2xx)
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        btnText && (btnText.textContent = "added with success");
        window.location.href = "/cart";
    })
        .catch((error) => {
        // Handle errors during the fetch request
        console.error("Error:", error);
        btnText && (btnText.textContent = "an error occurred");
    })
        .finally(() => {
        setTimeout(() => {
            btnText && (btnText.textContent = "add to cart");
        }, 1000);
    });
}
addToCartButton?.addEventListener("click", addToCart);

export { changeSlogantext, frontPlate, frontShapeSelector, plateImagesSlider, rearPlate, rearShapeSelector };
